import{a as n}from"./chunk-RAAYCPUM.js";function t(...e){return n(r,e)}function r(e){return[...e].reverse()}export{t as a};
